import React from "react";
import Select, { components } from "react-select";
const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, (child) => (child && child.type !== Placeholder ? child : null))}
    </ValueContainer>
  );
};

const SelectComponent = (props) => {
  const customStyles = {
    menu: (base) => ({
      ...base, zIndex: 9999
    }),
    container: (provided, state) => ({
      ...provided,
    }),
    menuList: () => ({
      maxHeight: 200,
      overflow: "auto"
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      overflow: "visible"
    }),
    singleValue: (provided, state) => ({
      ...provided,
      paddingTop: state.data.extraPadding && 5,
    }),
    placeholder: (provided, state) => ({
      ...provided,
      position: "absolute",
      top: state.hasValue || state.selectProps.inputValue ? "-13px" : "15%",
      backgroundColor: state.hasValue || state.selectProps.inputValue ? "white" : "transparent",
      transition: "top 0.1s, font-size 0.1s",
      fontSize: (state.hasValue || state.selectProps.inputValue) && 11,
      paddingRight: state.hasValue || state.selectProps.inputValue ? "4px" : "0px",
      paddingLeft: state.hasValue || state.selectProps.inputValue ? "4px" : "0px",
      display: state.hasValue ? props.noLabel ? "none" : "block" : "block"
    }),
    option: (style, { isSelected, data }) => ({ ...style, display: isSelected ? "none" : "block", color: data?.color })
  };


  const formatOptionLabel = (option, { context }) => {
    if (!option.rawHtml || context === "value") return option.label

    // در لیست بازشو، HTML کامل را نمایش بده
    return <div dangerouslySetInnerHTML={{ __html: option.rawHtml }} />;

  };

  return (
    <Select
      classNamePrefix="select"
      components={{
        ValueContainer: CustomValueContainer,
      }}
      onKeyDown={(e) => {
        if (!props.noClear) {
          if (e.key === "Escape") {
            e.target.value = null;
            if (!!props.onChange)
              props?.onChange([])
            else
              props?.field?.onChange([])
            e.stopPropagation()
            e.preventDefault()
          }
        }
      }}
      styles={customStyles}
      value={props?.value || props?.field?.value || ""}
      onChange={props?.onChange || props?.field?.onChange}
      closeMenuOnSelect={!props.isMulti}
      blurInputOnSelect={!props.isMulti}
      isClearable={!props.noClear}
      formatOptionLabel={formatOptionLabel}
      {...props}
    />
  );
};

export default SelectComponent;
